import { LOGIN_STATUS as loginStat } from '../../../utils/constant.utils';
import { loadUserSessionStorage } from '../../../utils/helpers.utils';
import { httpGet, httpPost } from '../../../utils/api.utils';
import {
    setLanguage, setLangConfodalOpen,
    getToolLanguages, setLanguageLoading, setAuthedUser
} from '../../../../app/constants/model-reducers/external/translation/translation.settings';

const defaultTranslationState = () => ({
    locale: "en_US",
    toLangLocale: '',
    languages: [],
    isLangConfirmModal: false,
    languageLoading: false
});
const initialState = defaultTranslationState();

export const translationAction = {
    setLanguage: (locale = null) => async (dispatch, state) => {
        var currLanguage = JSON.parse(sessionStorage.getItem('User')).Employee.LanguageLocale;
        dispatch({
            type: setLanguage,
            locale: locale == null ? state().translation.toLangLocale == "" ? currLanguage : state().translation.toLangLocale : locale,
            isLangConfirmModal: false
        });
        if (locale === null && state().translation.toLangLocale !== '') {
            dispatch({
                type: setLanguageLoading,
                languageLoading: true
            });
            var languageLocale = state().translation.toLangLocale;
            var url = sessionStorage.getItem('logInStatus') === loginStat.internal
                ? 'internal/profile/submitUserLanguage'
                : 'external/nav/saveUserLanguage';
            var isSuccessful = await httpPost(url, languageLocale);
            if (isSuccessful || isSuccessful.ok === false) {
                dispatch({
                    type: setLanguageLoading,
                    languageLoading: false
                });
            }
            if (sessionStorage.getItem('logInStatus') === loginStat.internal) {
                sessionStorage.setItem('UserLanguageLocale', state().translation.toLangLocale);
            } else {
                var user = loadUserSessionStorage();
                var updatedUser = {
                    ...user,
                    Employee: {
                        ...user.Employee,
                        LanguageLocale: state().translation.toLangLocale
                    }
                };
                sessionStorage.setItem('User', JSON.stringify(updatedUser));
                dispatch({
                    type: setAuthedUser,
                    userInfo: updatedUser
                });
            }
        }
    },
    setLangConfodalOpen: (isOpen, langLocale) => (dispatch) => {
        dispatch({
            type: setLangConfodalOpen,
            toLangLocale: isOpen ? langLocale : '',
            isLangConfirmModal: isOpen
        });
    },
    getToolLanguages: () => async (dispatch) => {
        var url = 'external/nav/getToolLanguages'
        var languages = await httpGet(url);
        dispatch({
            type: getToolLanguages,
            languages: languages != null && languages.length > 0 ? languages : []
        });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case setLanguage:
            return {
                ...state,
                locale: action.locale,
                isLangConfirmModal: action.isLangConfirmModal
            };
        case setLanguageLoading:
            return {
                ...state,
                languageLoading: action.languageLoading
            };
        case setLangConfodalOpen:
            return {
                ...state,
                toLangLocale: action.toLangLocale,
                isLangConfirmModal: action.isLangConfirmModal
            };
        case getToolLanguages:
            return {
                ...state,
                languages: action.languages
            };
        default:
            return state;
    }
};
